/**
 * Виды табов на странице редактирования
 */
export const enum ETabsKeys {
  SchoolEdit = 'school_edit',
  ParticipantsList = 'participants_list',
  ParticipantsImport = 'participants_import',
}
